export interface SettingState {
  theme: string
}

export default {
  namespaced: true,
  state: () => ({
    theme: ''
  } as SettingState),
  getters: {
    theme(state: SettingState): string {
      return state.theme
    }
  }
}
